import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { freeBetStore } from '@pascal/pascal-core/shared/core/store/freeBetStore';
import { doBetStore, gameStore, manualBetStore } from '../../../../store';
import { BetAmountSectionWr } from './betAmountSection';
import { DoBetAndAutoCashOutSectionWr } from './autoCashOutSection';

export const BetSection = observer(
  ({
    betAmount,
    isOpen,
    autoCashOutOdd,
    index,
    limits,
    isAutoCashOut,
    handleOpenNumPad,
    isLoaderActive,
    i,
    t,
  }) => {
    const {
      doBetSectionsData: {
        [i]: { isNextRoundBet, isBetAccepted, isDisabled, freeBetId },
      },
      freeBetMinOdd,
    } = doBetStore;
    const { activeFreeBet } = freeBetStore;
    const { setBetAmount, setAutoCashOutOdd, autoCashOutToggle, betsSectionsData } = manualBetStore;
    useEffect(() => {
      if ((!isBetAccepted && activeFreeBet.id) || freeBetId) {
        const currentBetAmount = activeFreeBet.amount || betsSectionsData[index].freeBetAmount;
        const currentOdd =
          betsSectionsData[index].freeBetCurrentOdd || activeFreeBet.minOdd || freeBetMinOdd;
        if (currentBetAmount) {
          setBetAmount(currentBetAmount, index);
        }
        setAutoCashOutOdd(currentOdd, index);
      } else if (!isBetAccepted && !activeFreeBet.id && limits.minBet && !freeBetId) {
        setBetAmount(limits.defaultBetAmount || limits.minBet, index);
        setAutoCashOutOdd(gameStore.defaultMinOdd, index);
        if (betsSectionsData[index].isAutoCashOut) {
          autoCashOutToggle(index);
        }
      }
    }, [activeFreeBet.id, freeBetId]);

    const disabledSection = isNextRoundBet || isBetAccepted || isDisabled;
    // todo for mobile hide options ${isBetAccepted ? 'hide' : ''}
    return (
      <div
        className={`crash-bet-content ${isOpen ? 'crash-bet-content-active' : ''}`}
        style={{ display: isOpen ? '' : 'none' }}
      >
        <div className={`crash-manual-bet ${disabledSection ? 'disabled' : ''}`}>
          <BetAmountSectionWr
            limits={limits}
            betAmount={betAmount}
            index={index}
            inputDisable={disabledSection}
            handleOpenNumPad={handleOpenNumPad}
            activeFreeBet={activeFreeBet}
            t={t}
          />
          <DoBetAndAutoCashOutSectionWr
            autoCashOutOdd={autoCashOutOdd}
            isAutoCashOut={isAutoCashOut}
            index={index}
            inputDisable={disabledSection}
            handleOpenNumPad={handleOpenNumPad}
            betAmount={betAmount}
            limits={limits}
            isLoaderActive={isLoaderActive}
            activeFreeBet={activeFreeBet}
            i={i}
            t={t}
          />
        </div>
      </div>
    );
  }
);
